((function(){

    const wishlist_add_remove_init = () => {
        const toggleWishlist = document.querySelector('[data-adev-add-wishlist]');
        if (!toggleWishlist) return;

        toggleWishlist.addEventListener('click', function(event) {
            event.preventDefault();
            const btn = document.querySelector('div[data-block-id*="swish_formerly_wishlist_king_wishlist_button_bl"] button');
            if (btn) btn.click();
        });
    }   

    wishlist_add_remove_init();


    const wishlist_drawer_opener_init = () => {
        const opener = document.querySelector('[aria-controls="adev-open-wishlist-drawer"]');
        if (!opener) return;

        opener.addEventListener('click', function(event) {
            event.preventDefault();
            const launcher = document.querySelector('button.kl-hub-launcher');
            if (launcher) launcher.click();
        });
    }

    wishlist_drawer_opener_init();

})());